import DashboardService from '@/src/services/dashboard'

const dashboardMixin = {
  methods: {
    loadDashboards() {
      return DashboardService.list()
        .then((response) => {
          return response
        })
        .catch((error) => error)
    },
  },
}

export default dashboardMixin
